/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function init_timers() {
const timers = document.querySelectorAll('div[data-pr-timer]');
if(timers){
  for (var i = 0, element; element = timers[i]; i++) {
    prCountdownTimer(element);
  }
}
const Forms = document.querySelectorAll('form[action="'+window.Shopify.routes.root+'cart/add"]')
Forms.forEach( form => {
  const inputRate = form.querySelector('input[name="properties[_rates]"]')
  if(inputRate){
    const inputlocalteCurrencyRate = form.querySelector('input[name="properties[_localeCurrencyRate]"]')
    if(inputlocalteCurrencyRate == null) {
      const inputCurrencyRate = document.createElement('input');
      inputCurrencyRate.type = 'hidden';
      inputCurrencyRate.name = 'properties[_localeCurrencyRate]';
      inputCurrencyRate.value = window.Shopify.currency.rate;
          form.appendChild(inputCurrencyRate)
    }
  }
})
}
init_timers()
function prCountdownTimer(element){
 var endDate = element.getAttribute('data-pr-timer');

 if(endDate == 'crazy-deal-banner'){
  const d = getCookie('cdb-timer') != '' ? new Date(getCookie('cdb-timer')) : new Date();
  const n = new Date();
  if(d.getTime() <= n.getTime()){
    n.setTime(n.getTime() + ( 8 * 60 * 60 * 1000));
    setCookie('cdb-timer',n.toUTCString());
    endDate = n.toUTCString();
  }else {
    endDate = d.toUTCString();
  }
 }

 var second = 1000,
     minute = second * 60,
     hour = minute * 60,
     day = hour * 24;

 var countDownDate = new Date(endDate).getTime(),
 countDownElement = setInterval(function() {
 var now = new Date().getTime(),
    distance = countDownDate - now,
    days = Math.floor(distance / (day)),
    hours = Math.floor((distance % (day)) / (hour)),
    minutes = Math.floor((distance % (hour)) / (minute)),
    seconds = Math.floor((distance % (minute)) / second);
    if(distance<=0){
      element.remove();
      clearInterval(countDownElement);
    }
    const inputDays = element.querySelector('.days');
    const inputHours = element.querySelector('.hours');
    const inputMinutes = element.querySelector('.minutes');
    const inputSeconds = element.querySelector('.seconds');
    if(inputDays){
      inputDays.innerText = ("0" + days).slice(-2);
    }

    if(inputHours){
      inputHours.innerText = ("0" + hours).slice(-2);
    }

    if(inputMinutes){
      inputMinutes.innerText = ("0" + minutes).slice(-2);
    }

    if(inputSeconds){
      inputSeconds.innerText = ("0" + seconds).slice(-2);
    }
   }, second)
}

function setCookie(cname, cvalue, path, exdays, exhours) {
  exdays = exdays ?? 1;
  exhours = exhours ?? 24;
  path = path ?? '/';
  const d = new Date();
  d.setTime(d.getTime() + (exdays * exhours * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path;
}

function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if(name == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }

    // Return null if not found
    return null;
}

(async function(productsIncluded){
  const routeRoot = window.Shopify.routes.root;
  const firstResult = await fetch(routeRoot+'pages/products-included').then((resp) => resp.json());
  productsIncluded.list = firstResult.list;
  productsIncluded.complete = (firstResult.total_pages == 1);
  if(firstResult.total_pages > 1){
    for(let _page = 2; _page <= firstResult.total_pages; _page++){
      const _result = await fetch(routeRoot+'pages/products-included?page='+_page).then((resp) => resp.json());
      productsIncluded.list = {...productsIncluded.list,..._result.list};
      productsIncluded.complete = (firstResult.total_pages == _page);
    }
  }
}(window.productsIncluded = window.productsIncluded || {}));

var r = document.querySelector(':root');
var rs = getComputedStyle(r);
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var header = $('#shopify-section-header');
//var navbarHeight = header.outerHeight();
var navbarHeight = parseInt(rs.getPropertyValue('--header-height'),10);

// on scroll, let the interval function know the user has scrolled
$(window).scroll(function(event){
  didScroll = true;
});

// run hasScrolled() and reset didScroll status
setInterval(function(){
  if(didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  var st = $(this).scrollTop();

  // make sure they scroll more than delta
  if(Math.abs(lastScrollTop - st) <= delta)
    return;
  // if they scrolled down and are past the navbar, add calss .nav-up
  // this is necsssary so you never see what is "behind" the navbar

  if (st > lastScrollTop && st > navbarHeight){
    // scroll down
    header.removeClass('nav-down').addClass('nav-up');
    r.style.setProperty('--header-is-sticky', '0');
  } else {
    //scroll up
    if(st + $(window).height() < $(document).height()) {
      header.removeClass('nav-up').addClass('nav-down');
      r.style.setProperty('--header-is-sticky', '1');
    }
  }
  lastScrollTop = st;
}

const animateCSS = (element, animation, prefix = 'animate__') =>
// We create a Promise and return it
new Promise((resolve, reject) => {
  const animationName = `${prefix}${animation}`;
  const node = document.querySelector(element);

  node.classList.add(`${prefix}animated`, animationName);

  // When the animation ends, we clean the classes and resolve the Promise
  function handleAnimationEnd(event) {
    event.stopPropagation();
    node.classList.remove(`${prefix}animated`, animationName);
    resolve('Animation ended');
  }

  node.addEventListener('animationend', handleAnimationEnd, {once: false});
});

document.addEventListener('product:added', function(event) {
  var iconCart = document.querySelector('.header__cart-icon .icon-state__primary .icon--cart');
  animateCSS('.header__cart-icon .icon-state__primary .icon--cart', 'rubberBand');
});

/*Video Reset for collections with the video box added to them*/
for(let prVideo of document.querySelectorAll('.pr-video-box__splash.product-item__image-wrapper--with-secondary video')){
  prVideo.addEventListener('mouseover', (e) => {
    var playPromise = e.target.play();
    if(playPromise !== undefined){
      playPromise.then(_ => {});
    }
  }, false);

  prVideo.addEventListener('mouseout', (e) => {
    var playPromise = e.target.play();
    if(playPromise !== undefined){
      playPromise.then(_ => {
        e.target.pause();
      });
    }
  }, false);
}

document.addEventListener("DOMContentLoaded", function() {
  var videos = [].slice.call(document.querySelectorAll("video.lazyVideo"));

  if ("IntersectionObserver" in window) {
    var videoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazyVideo");
          videoObserver.unobserve(video.target);
        }
      });
    });

    videos.forEach(function(video) {
      videoObserver.observe(video);
    });
  }
});

// Get the modal
/*
 * ES2015 accessible modal window system, using ARIA
 * Website: https://van11y.net/accessible-modal/
 * License MIT: https://github.com/nico3333fr/van11y-accessible-modal-window-aria/blob/master/LICENSE
 */
'use strict';

(function (doc) {

  'use strict';

  var MODAL_JS_CLASS = 'js-modal';
  var MODAL_ID_PREFIX = 'label_modal_';
  var MODAL_CLASS_SUFFIX = 'modal';
  var MODAL_DATA_BACKGROUND_ATTR = 'data-modal-background-click';
  var MODAL_PREFIX_CLASS_ATTR = 'data-modal-prefix-class';
  var MODAL_TEXT_ATTR = 'data-modal-text';
  var MODAL_CONTENT_ID_ATTR = 'data-modal-content-id';
  var MODAL_DESCRIBEDBY_ID_ATTR = 'data-modal-describedby-id';
  var MODAL_TITLE_ATTR = 'data-modal-title';
  var MODAL_FOCUS_TO_ATTR = 'data-modal-focus-toid';
  var MODAL_CLOSE_TEXT_ATTR = 'data-modal-close-text';
  var MODAL_CLOSE_TITLE_ATTR = 'data-modal-close-title';
  var MODAL_CLOSE_IMG_ATTR = 'data-modal-close-img';
  var MODAL_ROLE = 'dialog';

  var MODAL_BUTTON_CLASS_SUFFIX = 'modal-close';
  var MODAL_BUTTON_JS_ID = 'js-modal-close';
  var MODAL_BUTTON_JS_CLASS = 'js-modal-close';
  var MODAL_BUTTON_CONTENT_BACK_ID = 'data-content-back-id';
  var MODAL_BUTTON_FOCUS_BACK_ID = 'data-focus-back';

  var MODAL_WRAPPER_CLASS_SUFFIX = 'modal__wrapper';
  var MODAL_CONTENT_CLASS_SUFFIX = 'modal__content';
  var MODAL_CONTENT_JS_ID = 'js-modal-content';

  var MODAL_CLOSE_IMG_CLASS_SUFFIX = 'modal__closeimg';
  var MODAL_CLOSE_TEXT_CLASS_SUFFIX = 'modal-close__text';

  var MODAL_TITLE_ID = 'modal-title';
  var MODAL_TITLE_CLASS_SUFFIX = 'modal-title';

  var FOCUSABLE_ELEMENTS_STRING = "a[href], area[href], input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
  var WRAPPER_PAGE_JS = 'js-modal-page';

  var MODAL_JS_ID = 'js-modal';

  var MODAL_OVERLAY_ID = 'js-modal-overlay';
  var MODAL_OVERLAY_CLASS_SUFFIX = 'modal-overlay';
  var MODAL_OVERLAY_TXT = 'Close modal';
  var MODAL_OVERLAY_BG_ENABLED_ATTR = 'data-background-click';

  var VISUALLY_HIDDEN_CLASS = 'invisible';
  var NO_SCROLL_CLASS = 'no-scroll';

  var ATTR_ROLE = 'role';
  var ATTR_OPEN = 'open';
  var ATTR_LABELLEDBY = 'aria-label';
  var ATTR_DESCRIBEDBY = 'aria-describedby';
  var ATTR_HIDDEN = 'aria-hidden';
  //const ATTR_MODAL = 'aria-modal="true"';
  var ATTR_HASPOPUP = 'aria-haspopup';
  var ATTR_HASPOPUP_VALUE = 'dialog';

  var findById = function findById(id) {
    return doc.getElementById(id);
  };

  var addClass = function addClass(el, className) {
    if (el.classList) {
      el.classList.add(className); // IE 10+
    } else {
        el.className += ' ' + className; // IE 8+
      }
  };

  var removeClass = function removeClass(el, className) {
    if (el.classList) {
      el.classList.remove(className); // IE 10+
    } else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' '); // IE 8+
      }
  };

  var hasClass = function hasClass(el, className) {
    if (el.classList) {
      return el.classList.contains(className); // IE 10+
    } else {
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className); // IE 8+ ?
      }
  };
  /*const wrapInner = (el, wrapper_el) => { // doesn't work on IE/Edge, f…
      while (el.firstChild)
          wrapper_el.append(el.firstChild);
      el.append(wrapper_el);
   }*/
  function wrapInner(parent, wrapper) {
    if (typeof wrapper === "string") wrapper = document.createElement(wrapper);

    parent.appendChild(wrapper);

    while (parent.firstChild !== wrapper) wrapper.appendChild(parent.firstChild);
  }

  function remove(el) {
    /* node.remove() is too modern for IE≤11 */
    el.parentNode.removeChild(el);
  }

  /* gets an element el, search if it is child of parent class, returns id of the parent */
  var searchParent = function searchParent(el, parentClass) {
    var found = false;
    var parentElement = el.parentNode;
    while (parentElement && found === false) {
      if (hasClass(parentElement, parentClass) === true) {
        found = true;
      } else {
        parentElement = parentElement.parentNode;
      }
    }
    if (found === true) {
      return parentElement.getAttribute('id');
    } else {
      return '';
    }
  };

  /**
   * Create the template for an overlay
   * @param  {Object} config
   * @return {String}
   */
  var createOverlay = function createOverlay(config) {

    var id = MODAL_OVERLAY_ID;
    var overlayText = config.text || MODAL_OVERLAY_TXT;
    var overlayClass = config.prefixClass + MODAL_OVERLAY_CLASS_SUFFIX;
    var overlayBackgroundEnabled = config.backgroundEnabled === 'disabled' ? 'disabled' : 'enabled';

    return '<span\n                    id="' + id + '"\n                    class="' + overlayClass + '"\n                    ' + MODAL_OVERLAY_BG_ENABLED_ATTR + '="' + overlayBackgroundEnabled + '"\n                    title="' + overlayText + '"\n                    >\n                    <span class="' + VISUALLY_HIDDEN_CLASS + '">' + overlayText + '</span>\n                  </span>';
  };

  /**
   * Create the template for a modal
   * @param  {Object} config
   * @return {String}
   */
  var createModal = function createModal(config) {

    var id = MODAL_JS_ID;
    var modalClassName = config.modalPrefixClass + MODAL_CLASS_SUFFIX;
    var modalClassWrapper = config.modalPrefixClass + MODAL_WRAPPER_CLASS_SUFFIX;
    var buttonCloseClassName = config.modalPrefixClass + MODAL_BUTTON_CLASS_SUFFIX;
    var buttonCloseInner = config.modalCloseImgPath ? '<img src="' + config.modalCloseImgPath + '" alt="' + config.modalCloseText + '" class="' + config.modalPrefixClass + MODAL_CLOSE_IMG_CLASS_SUFFIX + '" />' : '<span class="' + config.modalPrefixClass + MODAL_CLOSE_TEXT_CLASS_SUFFIX + '">\n                                          ' + config.modalCloseText + '\n                                         </span>';
    var contentClassName = config.modalPrefixClass + MODAL_CONTENT_CLASS_SUFFIX;
    var titleClassName = config.modalPrefixClass + MODAL_TITLE_CLASS_SUFFIX;
    var title = config.modalTitle !== '' ? '<h1 id="' + MODAL_TITLE_ID + '" class="' + titleClassName + '">\n                                          ' + config.modalTitle + '\n                                         </h1>' : '';
    var button_close = '<button type="button" aria-label="Close" class="' + MODAL_BUTTON_JS_CLASS + ' ' + buttonCloseClassName + '" id="' + MODAL_BUTTON_JS_ID + '" title="' + config.modalCloseTitle + '" ' + MODAL_BUTTON_CONTENT_BACK_ID + '="' + config.modalContentId + '" ' + MODAL_BUTTON_FOCUS_BACK_ID + '="' + config.modalFocusBackId + '">\n                               ' + buttonCloseInner + '\n                              </button>';
    var content = config.modalText;
    var describedById = config.modalDescribedById !== '' ? ATTR_DESCRIBEDBY + '="' + config.modalDescribedById + '"' : '';

    // If there is no content but an id we try to fetch content id
    if (content === '' && config.modalContentId) {
      var contentFromId = findById(config.modalContentId);
      if (contentFromId) {
        content = '<div id="' + MODAL_CONTENT_JS_ID + '">\n                              ' + contentFromId.innerHTML + '\n                             </div';
        // we remove content from its source to avoid id duplicates, etc.
        contentFromId.innerHTML = '';
      }
    }

    return '<dialog aria-modal="true" id="' + id + '" class="' + modalClassName + '" ' + ATTR_ROLE + '="' + MODAL_ROLE + '" ' + describedById + ' ' + ATTR_OPEN + ' ' + ATTR_LABELLEDBY + '="' + MODAL_TITLE_ID + '">\n                    <div role="document" class="' + modalClassWrapper + '">\n                      ' + button_close + '\n                      <div class="' + contentClassName + '">\n                        ' + title + '\n                        ' + content + '\n                      </div>\n                    </div>\n                  </dialog>';
  };

  var closeModal = function closeModal(config) {

    remove(config.modal);
    remove(config.overlay);

    if (config.contentBackId !== '') {
      var contentBack = findById(config.contentBackId);
      if (contentBack) {
        contentBack.innerHTML = config.modalContent;
      }
    }

    if (config.modalFocusBackId) {
      var contentFocus = findById(config.modalFocusBackId);
      if (contentFocus) {
        contentFocus.focus();
      }
    }
  };

  /** Find all modals inside a container
   * @param  {Node} node Default document
   * @return {Array}
   */
  var $listModals = function $listModals() {
    var node = arguments.length <= 0 || arguments[0] === undefined ? doc : arguments[0];
    return [].slice.call(node.querySelectorAll('.' + MODAL_JS_CLASS));
  };

  /**
   * Build modals for a container
   * @param  {Node} node
   */
  var attach = function attach(node) {
    var addListeners = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    $listModals(node).forEach(function (modal_node) {

      var iLisible = Math.random().toString(32).slice(2, 12);
      var wrapperBody = findById(WRAPPER_PAGE_JS);
      var body = doc.querySelector('body');

      modal_node.setAttribute('id', MODAL_ID_PREFIX + iLisible);
      modal_node.setAttribute(ATTR_HASPOPUP, ATTR_HASPOPUP_VALUE);

      if (wrapperBody === null || wrapperBody.length === 0) {
        var wrapper = doc.createElement('DIV');
        wrapper.setAttribute('id', WRAPPER_PAGE_JS);
        wrapInner(body, wrapper);
      }
    });

    if (addListeners) {

      /* listeners */
      ['click', 'keydown'].forEach(function (eventName) {

        doc.body.addEventListener(eventName, function (e) {

          // click on link modal
          var parentModalLauncher = searchParent(e.target, MODAL_JS_CLASS);
          if ((hasClass(e.target, MODAL_JS_CLASS) === true || parentModalLauncher !== '') && eventName === 'click') {
            var body = doc.querySelector('body');
            var modalLauncher = parentModalLauncher !== '' ? findById(parentModalLauncher) : e.target;
            var modalPrefixClass = modalLauncher.hasAttribute(MODAL_PREFIX_CLASS_ATTR) === true ? modalLauncher.getAttribute(MODAL_PREFIX_CLASS_ATTR) + '-' : '';
            var modalText = modalLauncher.hasAttribute(MODAL_TEXT_ATTR) === true ? modalLauncher.getAttribute(MODAL_TEXT_ATTR) : '';
            var modalContentId = modalLauncher.hasAttribute(MODAL_CONTENT_ID_ATTR) === true ? modalLauncher.getAttribute(MODAL_CONTENT_ID_ATTR) : '';
            var modalDescribedById = modalLauncher.hasAttribute(MODAL_DESCRIBEDBY_ID_ATTR) === true ? modalLauncher.getAttribute(MODAL_DESCRIBEDBY_ID_ATTR) : '';
            var modalTitle = modalLauncher.hasAttribute(MODAL_TITLE_ATTR) === true ? modalLauncher.getAttribute(MODAL_TITLE_ATTR) : '';
            var modalCloseText = modalLauncher.hasAttribute(MODAL_CLOSE_TEXT_ATTR) === true ? modalLauncher.getAttribute(MODAL_CLOSE_TEXT_ATTR) : MODAL_OVERLAY_TXT;
            var modalCloseTitle = modalLauncher.hasAttribute(MODAL_CLOSE_TITLE_ATTR) === true ? modalLauncher.getAttribute(MODAL_CLOSE_TITLE_ATTR) : modalCloseText;
            var modalCloseImgPath = modalLauncher.hasAttribute(MODAL_CLOSE_IMG_ATTR) === true ? modalLauncher.getAttribute(MODAL_CLOSE_IMG_ATTR) : '';
            var backgroundEnabled = modalLauncher.hasAttribute(MODAL_DATA_BACKGROUND_ATTR) === true ? modalLauncher.getAttribute(MODAL_DATA_BACKGROUND_ATTR) : '';
            var modalGiveFocusToId = modalLauncher.hasAttribute(MODAL_FOCUS_TO_ATTR) === true ? modalLauncher.getAttribute(MODAL_FOCUS_TO_ATTR) : '';

            var wrapperBody = findById(WRAPPER_PAGE_JS);

            // insert overlay
            body.insertAdjacentHTML('beforeEnd', createOverlay({
              text: modalCloseTitle,
              backgroundEnabled: backgroundEnabled,
              prefixClass: modalPrefixClass
            }));

            // insert modal
            body.insertAdjacentHTML('beforeEnd', createModal({
              modalText: modalText,
              modalPrefixClass: modalPrefixClass,
              backgroundEnabled: modalContentId,
              modalTitle: modalTitle,
              modalCloseText: modalCloseText,
              modalCloseTitle: modalCloseTitle,
              modalCloseImgPath: modalCloseImgPath,
              modalContentId: modalContentId,
              modalDescribedById: modalDescribedById,
              modalFocusBackId: modalLauncher.getAttribute('id')
            }));

            // hide page
            wrapperBody.setAttribute(ATTR_HIDDEN, 'true');

            // add class noscroll to body
            addClass(body, NO_SCROLL_CLASS);

            // give focus to close button or specified element
            var closeButton = findById(MODAL_BUTTON_JS_ID);
            if (modalGiveFocusToId !== '') {
              var focusTo = findById(modalGiveFocusToId);
              if (focusTo) {
                focusTo.focus();
              } else {
                closeButton.focus();
              }
            } else {
              closeButton.focus();
            }

            e.preventDefault();
          }

          // click on close button or on overlay not blocked
          var parentButton = searchParent(e.target, MODAL_BUTTON_JS_CLASS);
          if ((e.target.getAttribute('id') === MODAL_BUTTON_JS_ID || parentButton !== '' || e.target.getAttribute('id') === MODAL_OVERLAY_ID || hasClass(e.target, MODAL_BUTTON_JS_CLASS) === true) && eventName === 'click') {
            var body = doc.querySelector('body');
            var wrapperBody = findById(WRAPPER_PAGE_JS);
            var modal = findById(MODAL_JS_ID);
            var modalContent = findById(MODAL_CONTENT_JS_ID) ? findById(MODAL_CONTENT_JS_ID).innerHTML : '';
            var overlay = findById(MODAL_OVERLAY_ID);
            var modalButtonClose = findById(MODAL_BUTTON_JS_ID);
            var modalFocusBackId = modalButtonClose.getAttribute(MODAL_BUTTON_FOCUS_BACK_ID);
            var contentBackId = modalButtonClose.getAttribute(MODAL_BUTTON_CONTENT_BACK_ID);
            var backgroundEnabled = overlay.getAttribute(MODAL_OVERLAY_BG_ENABLED_ATTR);

            if (!(e.target.getAttribute('id') === MODAL_OVERLAY_ID && backgroundEnabled === 'disabled')) {

              closeModal({
                modal: modal,
                modalContent: modalContent,
                overlay: overlay,
                modalFocusBackId: modalFocusBackId,
                contentBackId: contentBackId,
                backgroundEnabled: backgroundEnabled,
                fromId: e.target.getAttribute('id')
              });

              // show back page
              wrapperBody.removeAttribute(ATTR_HIDDEN);

              // remove class noscroll to body
              removeClass(body, NO_SCROLL_CLASS);
            }
          }

          // strike a key when modal opened
          if (findById(MODAL_JS_ID) && eventName === 'keydown') {
            var body = doc.querySelector('body');
            var wrapperBody = findById(WRAPPER_PAGE_JS);
            var modal = findById(MODAL_JS_ID);
            var modalContent = findById(MODAL_CONTENT_JS_ID) ? findById(MODAL_CONTENT_JS_ID).innerHTML : '';
            var overlay = findById(MODAL_OVERLAY_ID);
            var modalButtonClose = findById(MODAL_BUTTON_JS_ID);
            var modalFocusBackId = modalButtonClose.getAttribute(MODAL_BUTTON_FOCUS_BACK_ID);
            var contentBackId = modalButtonClose.getAttribute(MODAL_BUTTON_CONTENT_BACK_ID);
            var $listFocusables = [].slice.call(modal.querySelectorAll(FOCUSABLE_ELEMENTS_STRING));

            // esc
            if (e.keyCode === 27) {

              closeModal({
                modal: modal,
                modalContent: modalContent,
                overlay: overlay,
                modalFocusBackId: modalFocusBackId,
                contentBackId: contentBackId
              });

              // show back page
              wrapperBody.removeAttribute(ATTR_HIDDEN);

              // remove class noscroll to body
              removeClass(body, NO_SCROLL_CLASS);
            }

            // tab or Maj Tab in modal => capture focus
            if (e.keyCode === 9 && $listFocusables.indexOf(e.target) >= 0) {

              // maj-tab on first element focusable => focus on last
              if (e.shiftKey) {
                if (e.target === $listFocusables[0]) {
                  $listFocusables[$listFocusables.length - 1].focus();
                  e.preventDefault();
                }
              } else {
                // tab on last element focusable => focus on first
                if (e.target === $listFocusables[$listFocusables.length - 1]) {
                  $listFocusables[0].focus();
                  e.preventDefault();
                }
              }
            }

            // tab outside modal => put it in focus
            if (e.keyCode === 9 && $listFocusables.indexOf(e.target) === -1) {
              e.preventDefault();
              $listFocusables[0].focus();
            }
          }
        }, true);
      });
    }
  };

  var onLoad = function onLoad() {
    attach();
    document.removeEventListener('DOMContentLoaded', onLoad);
  };

  document.addEventListener('DOMContentLoaded', onLoad);

  window.van11yAccessibleModalWindowAria = attach;
})(document);

/**
 * van11y-accessible-tab-panel-aria - ES2015 accessible tabs panel system, using ARIA (compatible IE9+ when transpiled)
 * @version v2.0.4
 * @link https://van11y.net/accessible-tab-panel/
 * @license MIT : https://github.com/nico3333fr/van11y-accessible-tab-panel-aria/blob/master/LICENSE
 */
"use strict";function _defineProperty(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}!function(e){var t="js-tabs",r="js-tablist",i="js-tablist__item",l="js-tablist__link",n="js-tabcontent",a="js-link-to-tab",o="data-tabs-prefix-class",c="data-hx",u="data-tabs-generated-hx-class",s="data-existing-hx",f="data-selected",d="label_",b="tabs",y="tabs__list",v="tabs__item",A="tabs__link",p="tabs__content",g="invisible",h="tablist",_="tab",m="tabpanel",S="presentation",P="role",q="aria-labelledby",k="aria-hidden",x="aria-controls",E="aria-selected",D=1e3,C=window.location.hash.replace("#",""),L=function(t){return e.getElementById(t)},w=function(e,t){e.classList?e.classList.add(t):e.className+=" "+t},j=function(e,t){return e.classList?e.classList.contains(t):new RegExp("(^| )"+t+"( |$)","gi").test(e.className)},T=function(e,t){Object.keys(t).forEach(function(r){e.setAttribute(r,t[r])})},K=function(e){e.forEach(function(e){var t;T(e,(t={},_defineProperty(t,E,"false"),_defineProperty(t,"tabindex","-1"),t))})},M=function(e){e.forEach(function(e){e.setAttribute(k,!0)})},N=function(e){var t,r=L(e.getAttribute(x));T(e,(t={},_defineProperty(t,E,"true"),_defineProperty(t,"tabindex","0"),t)),r.removeAttribute(k),setTimeout(function(){e.focus()},0),setTimeout(function(){history.pushState(null,null,location.pathname+location.search+"#"+e.getAttribute(x))},D)},O=function(e,t,r,i){var n=void 0;e.forEach(function(e,t){"true"===e.querySelector("."+l).getAttribute(E)&&(n=t)}),K(t),M(r),"next"===i&&(N(t[n+1]),setTimeout(function(){t[n+1].focus()},0)),"prev"===i&&(N(t[n-1]),setTimeout(function(){t[n-1].focus()},0))},B=function(e,t){for(var r=!1,i=e.parentNode;i&&r===!1;)j(i,t)===!0?r=!0:i=i.parentNode;return r===!0?i.getAttribute("id"):""},H=function(){var r=arguments.length<=0||void 0===arguments[0]?e:arguments[0];return[].slice.call(r.querySelectorAll("."+t))},I=function(e){H(e).forEach(function(e){var t=Math.random().toString(32).slice(2,12),a=e.hasAttribute(o)===!0?e.getAttribute(o)+"-":"",D=e.hasAttribute(c)===!0?e.getAttribute(c):"",N=e.hasAttribute(u)===!0?e.getAttribute(u):g,O=e.hasAttribute(s)===!0?e.getAttribute(s):"",H=[].slice.call(e.querySelectorAll("."+r)),I=[].slice.call(e.querySelectorAll("."+i)),R=[].slice.call(e.querySelectorAll("."+l)),$=[].slice.call(e.querySelectorAll("."+n)),z=!0;if(w(e,a+b),e.setAttribute("id",b+t),H.forEach(function(e){var r;w(e,a+y),T(e,(r={},_defineProperty(r,P,h),_defineProperty(r,"id",y+t),r))}),I.forEach(function(e,r){var i;w(e,a+v),T(e,(i={},_defineProperty(i,P,S),_defineProperty(i,"id",v+t+"-"+(r+1)),i))}),R.forEach(function(e){var t,r,i=e.getAttribute("href").replace("#",""),l=L(i),n=e.innerText,o=e.hasAttribute(f)===!0;if(w(e,a+A),T(e,(t={id:d+i},_defineProperty(t,P,_),_defineProperty(t,x,i),_defineProperty(t,"tabindex","-1"),_defineProperty(t,E,"false"),t)),T(l,(r={},_defineProperty(r,k,"true"),_defineProperty(r,P,m),_defineProperty(r,q,d+i),r)),w(l,a+p),o&&z&&(z=!1,T(e,_defineProperty({tabindex:"0"},E,"true")),T(l,_defineProperty({},k,"false"))),""!==D){var c=document.createElement(D);c.setAttribute("class",N),c.setAttribute("tabindex","0"),c.innerHTML=n,l.insertBefore(c,l.firstChild)}if(""!==O){var u=[].slice.call(l.querySelectorAll(O+":first-child"));u.forEach(function(e){e.setAttribute("tabindex","0")})}e.removeAttribute("href")}),""!==C){var F=L(C);if(null!==F&&null!==e.querySelector("#"+C))if(j(F,n)===!0){K(R),M($),F.removeAttribute(k);var G=L(d+C);T(G,_defineProperty({tabindex:"0"},E,"true")),z=!1}else{var J=B(F,n);if(""!==J){K(R),M($);var Q=L(J);Q.removeAttribute(k);var U=L(d+J);T(U,_defineProperty({tabindex:"0"},E,"true")),z=!1}}}if(z===!0){T(R[0],_defineProperty({tabindex:"0"},E,"true"));var V=L(R[0].getAttribute(x));V.removeAttribute(k)}})};["click","keydown"].forEach(function(r){e.body.addEventListener(r,function(e){var o=B(e.target,l);if((j(e.target,l)===!0||""!==o)&&"click"===r){var c=j(e.target,l)===!0?e.target:L(o),u=B(e.target,t),s=L(u),f=[].slice.call(s.querySelectorAll("."+l)),d=[].slice.call(s.querySelectorAll("."+n));K(f),M(d),N(c),e.preventDefault()}if((j(e.target,l)===!0||""!==o)&&"keydown"===r){var u=B(e.target,t),s=L(u),b=[].slice.call(s.querySelectorAll("."+i)),f=[].slice.call(s.querySelectorAll("."+l)),d=[].slice.call(s.querySelectorAll("."+n)),y=b[0].querySelector("."+l),v=b[b.length-1].querySelector("."+l);36===e.keyCode?(K(f),M(d),N(y),e.preventDefault()):35===e.keyCode?(K(f),M(d),N(v),e.preventDefault()):37!==e.keyCode&&38!==e.keyCode||e.ctrlKey?40!==e.keyCode&&39!==e.keyCode||e.ctrlKey||("true"===v.getAttribute(E)?(K(f),M(d),N(y),e.preventDefault()):(O(b,f,d,"next"),e.preventDefault())):"true"===y.getAttribute(E)?(K(f),M(d),N(v),e.preventDefault()):(O(b,f,d,"prev"),e.preventDefault())}var A=B(e.target,n);""!==A&&"keydown"===r&&!function(){var r=L(L(A).getAttribute(q)),a=B(e.target,t),o=L(a),c=[].slice.call(o.querySelectorAll("."+i)),u=[].slice.call(o.querySelectorAll("."+l)),s=[].slice.call(o.querySelectorAll("."+n)),f=c[0].querySelector("."+l),d=c[c.length-1].querySelector("."+l);38===e.keyCode&&e.ctrlKey&&(setTimeout(function(){r.focus()},0),e.preventDefault()),33===e.keyCode&&e.ctrlKey&&(r.focus(),e.preventDefault(),"true"===f.getAttribute(E)?(K(u),M(s),N(d)):O(c,u,s,"prev")),34===e.keyCode&&e.ctrlKey&&(r.focus(),e.preventDefault(),"true"===d.getAttribute(E)?(K(u),M(s),N(f)):O(c,u,s,"next"))}();var p=B(e.target,a);if((j(e.target,a)===!0||""!==p)&&"click"===r){var g=j(e.target,a)===!0?e.target.getAttribute("href").replace("#",""):L(p).replace("#",""),h=L(g),_=L(h.getAttribute(q)),u=B(e.target,t),s=L(u),f=[].slice.call(s.querySelectorAll("."+l)),d=[].slice.call(s.querySelectorAll("."+n));K(f),M(d),N(_),e.preventDefault()}},!0)});var R=function $(){I(),document.removeEventListener("DOMContentLoaded",$)};document.addEventListener("DOMContentLoaded",R),window.van11yAccessibleTabPanelAria=I}(document);

  /* PRV Alert Expand/Collapse */
  const fnmap = {
    'toggle': 'toggle',
    'show': 'add',
    'hide': 'remove'
  };

  const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach(target => {
      target.classList[fnmap[cmd]]('invisible');
    });
  }

  const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'));
  document.addEventListener('click', (ev) => {
    const elm = ev.target;
    if (triggers.includes(elm)) {
      ev.preventDefault();
      const selector = elm.getAttribute('data-target');
      collapse(selector, 'toggle');
    }
  }, false);

  /* PRV Klaviyo Feedback */
  document.addEventListener('click', function (event) {
      if (!event.target.closest('.prv-panel-open')) return;
      document.querySelector('.prv-button-wrap').classList.toggle('hide');
      document.querySelector('.prv-feedback-panel').classList.toggle('hide');
  }, false);

  document.addEventListener('click', function (event) {
      if (!event.target.closest('.prv-panel-close')) return;
      document.querySelector('.prv-feedback-panel').classList.toggle('hide');
      document.querySelector('.prv-button-wrap').classList.toggle('hide');
  }, false);

  document.addEventListener('click', function(event){
    if(!event.target.closest('.header__action-item-link.header__account-icon')) return;
      document.querySelector('body').classList.toggle('no-mobile-scroll');
  }, false);

  const feedbackHidden = localStorage.getItem('feedbackHidden');
  if(feedbackHidden === 'true') {
    document.querySelector('.prv-panel-container')?.classList.add('hide');
  } else {
    document.querySelector('.prv-panel-container')?.classList.remove('hide');
  }
  document.addEventListener('click', function(event){
    if(!event.target.closest('.prv-close-all')) return;
      localStorage.setItem('feedbackHidden', 'true');
      document.querySelector('.prv-panel-container')?.classList.add('hide');
  }, false);

  //var modalSelector = document.querySelector('[data-modal-content-id]');
  document.addEventListener('click', function(event){
    if(!event.target.closest('.js-modal')) return;
    //document.querySelector('#js-modal video').play();
    var prProduct = event.target.closest('.js-modal').getAttribute('prProduct')
    var prVideo = event.target.closest('.js-modal').getAttribute('prVideo');
    var prPosition =  event.target.closest('.js-modal').getAttribute('data-position');

    if (prPosition) {
      if (prPosition.includes('pdp')) {
        var pdpContainers = document.querySelectorAll('.cld-container-'+ prPosition);
        if (pdpContainers.length > 1) {
          var dupeContainer = document.getElementById('cld-container-'+ prPosition);
          dupeContainer.parentNode.removeChild(dupeContainer);
        }
      }
      var videoContainer = document.getElementById('cld-container-'+ prPosition);
      videoContainer.innerHTML = '';
      videoContainer.innerHTML = '<video id="cld-player-'+prPosition+'" class="cld-video-player cld-fluid" controls playsinline></video>';
      var videoUrl =  document.getElementById("cld-container-"+prPosition).getAttribute('data-video-url');
      var eventPlayer = cloudinary.videoPlayer('cld-player-'+ prPosition, { playedEventTimes: [3, 10],
        /*
      analytics: {
        events: [
        'play',
        'pause',
        'percentsplayed',
        'start',
        'ended',
        'fullscreenchange']
        }*/
      });
      eventPlayer.videoElement.title = event.target.closest('.js-modal').getAttribute('data-video-title');
      if(isNaN(prPosition)) {
        eventPlayer.source(videoUrl).play();
      } else {
        eventPlayer.source(videoUrl.replace("video/upload", "video/upload/b_blurred:1000,c_pad,h_720,w_1280/w_800")).play();
      }
      var autoEventTypes = ['sourcechanged', 'timeplayed', 'percentsplayed', 'ended'];
      var manualEventTypes = ['play', 'pause', 'volumechange', 'mute', 'unmute', 'fullscreenchange', 'seek'];

      autoEventTypes.forEach(function(eventType) {
        eventPlayer.on(eventType, function(event) {
        var eventStr = startTime() + " " + eventType;
        var data = '';
        if (event.eventData) {
            eventStr = eventStr + ": " + JSON.stringify(event.eventData)
            data = JSON.stringify(event.eventData);
        }
        //updateOnEvent(eventStr,true, eventPlayer, eventType, data);
        })
       });

       manualEventTypes.forEach(function(eventType) {
        eventPlayer.on(eventType, function(event) {
        var eventStr = startTime() + " " + eventType;
        var data = '';
        if (event.eventData) {
            eventStr = eventStr + ": " + JSON.stringify(event.eventData)
            data = JSON.stringify(event.eventData);
        }
        //updateOnEvent(eventStr,false, eventPlayer, eventType, data);
        })
       });
    }

    if (prVideo) {
      //prGAClickTracking('watch_video', prProduct, prVideo);
    }
  }, false);

  function updateOnEvent(eventStr,automatic, eventPlayer, eventType, data) {
    dataLayer.push({
       'event': "video."+ eventType,
       'video.url' : eventPlayer.videoElement.src,
       'video.data' : data,
       'video.automatic' : automatic,
       'video.title' : eventPlayer.videoElement.title
     });
 }

 function startTime() {
         var today = new Date(),
             h = checkTime(today.getHours()),
             m = checkTime(today.getMinutes()),
             s = checkTime(today.getSeconds());
         return (h + ":" + m + ":" + s);
 }

 function checkTime(i) {
         return (i < 10) ? "0" + i : i;
 }

  /*document.addEventListener('click', function(event){
    if(!event.target.closest('.js-modal-close')) return;
    document.querySelector('#js-modal video').pause();
  }, false);*/

  function prGAClickTracking(event, product, videoType) {
    if (window.ga && ga.loaded) {
      gtag('event', event, {
        'event_category': videoType,
        'event_action': event,
        'event_label': product

      });
    }
    clarity('set', event, videoType);
  }

/*
* Add to cart handler
*/
function addToCartHandler(event){
  event.preventDefault();

  const obj = $(this);
  const isBogo = obj.hasClass('product-form__bogo');
  const rates = obj.attr('data-rates') ?? false;
  const isSearchPage = obj.hasClass('fs-add-to-cart-button');
  const wrapperSelector = isSearchPage ? '.product-card' : 'form';
  const quantitySelector = isSearchPage ? '.fs-quantity-selector-input' : '.quantity-selector-product__value';
  let variantId = obj.attr("var_id");
  const qtyVal = parseInt(obj
    .closest(wrapperSelector)
    .find(quantitySelector)
    .val() ?? 1);

  if (isSearchPage) {
    // display add to cart loading animation
    obj.find('.add-to-cart-spinner-text-wrapper').prepend('<svg height="28" width="28" class="svelte-spinner fs-result-page-n2keu2" viewBox="0 0 32 32" style="animation-duration: 550ms;"><circle role="presentation" cx="16" cy="16" r="10" stroke="white" fill="none" stroke-width="2" stroke-dasharray="47.12388980384689,100" stroke-linecap="round"></circle></svg>');
    const productHandle = obj.closest(wrapperSelector).find('a.fs-product-main-image-wrapper').attr('href');
    $.getJSON(productHandle + '.js', function(product) {
      variantId = product.variants[0].id
      addToCart(variantId, qtyVal, isBogo, rates, () => {
        obj.find('.add-to-cart-spinner-text-wrapper .svelte-spinner').remove();
      });
    });
  } else {
    addToCart(variantId, qtyVal, isBogo, rates, () => {
      const section = obj.closest('section[data-section-settings]');
      if (section.length > 0) {
        const sectionSettings = JSON.parse(section.attr('data-section-settings'));
        if (sectionSettings['isQuickView'] && window.theme.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('modal:close'));
        }
      }
    });
  }
}

function addToCart(variantId, quantity, isBogo = false, rates, callback) {
  quantity = isBogo ? quantity * 2 : quantity;

  let addToCartData = {
    quantity: quantity,
    id: variantId,
  };

  let properties = {};

  if (isBogo) {
    properties['_hasBogo'] = "hasBogo";
  }

  if (rates) {
    properties['_rates'] = rates;
    properties['_localeCurrencyRate'] = window.Shopify.currency.rate;
  }

  if(Object.keys(properties).length > 0){
    addToCartData['properties'] = properties;
  }


  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: addToCartData,
    dataType: "json",
    success: function (data) {
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            quantity: quantity
          },
        })
      );
    },
    complete: function() {
      if (typeof callback === 'function') {
        callback();
      }
    }
  });
}

(function ($) {
    $(document).on("click", ".product-form__bogo:visible", addToCartHandler);
})(jQuery);

/*
* BOGO Qty Helper - Free qty input form from Mini Cart and Cart
*/
function updateProductCartLineItem(variantId,newQty,diffQty,properties,updateBuble = true){

  let data = {
    quantity: newQty,
    id: variantId
  }
  if(properties){
    data = {
      ...data,
      ...properties
    }
  }
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function(data){
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: updateBuble,
        detail: {
          quantity: diffQty
        }
      }));
    }
  });
}
(function($){
   $(document).on('keydown','#mini-cart', function(event){
    if (event.keyCode == '13') {
      event.preventDefault();
      $('#mini-cart').focus();
      $(event.target).focus();
      return false;
    }
  });
  $(document).on('change','.quantity-selector__value_bogo', function(event){
    event.preventDefault();
    var obj=$(this);
    var newQty = obj.val()*2;
    var currentQty = obj.attr('data-current-value');
    var diffQty = newQty - currentQty

    updateProductCartLineItem(obj.attr("var_id"),newQty,diffQty)
  });
}(jQuery));

/*
* BOGO Qty Helper - Delete item from cart
*/
function removeProductCartLineItem(variantId,diffQty,updateBuble = true,callback){
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      quantity: 0,
      id: variantId
    },
    dataType: 'json',
    success: function(data){
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: updateBuble,
        detail: {
          quantity: diffQty
        }
      }));
      if (typeof callback === 'function') {
        callback();
      }
    }
  });
}
(function($){
  $(document).on('click','.line-item__remove-action-link__bogo', function(event){
    event.preventDefault();
    var obj=$(this);
    var newQty = 0;
    var currentQty = obj.attr('data-current-value');
    var diffQty = -currentQty
    removeProductCartLineItem(obj.attr("var_id"),diffQty)
  });
}(jQuery));

/*
* Handler to update on several items at the same time
*/
function updateProductCartLineItems(items,diffQty,callback){

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {"updates":items},
    dataType: 'json',
    success: function(data){
      if(diffQty){
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            quantity: diffQty
          }
        }));
      }
      if (typeof callback === 'function') {
        callback();
      }
    }
  });
}

/*
* Handler to add on several items at the same time
*/
function addProductCartLineItems(items,diffQty,callback){

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {"items":items},
    dataType: 'json',
    success: function(data){
      if(diffQty){
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            quantity: diffQty
          }
        }));
      }
      if (typeof callback === 'function') {
        callback();
      }
    }
  });
}

/*
* BOGO Qty Helper - Revert items bogo from cart validation
*/
function variantValidation(toValidateVariants) {
  const toDelete = {}
  const toAdd = []
  let totalQuantityToDelete = 0;

  const requests = toValidateVariants.map((el,id) => {
    if(el.toDelete){
      toDelete[el.variantId] = 0;
      totalQuantityToDelete += el.currentQty;
    }
    if(el.hasBogo || el.hasRates){
      return fetch(el.url+"&view=metafields").then((response) => response.json())
    }
    return false;
  });

  Promise.all(requests).then((metafields) => {
    toValidateVariants.forEach((el,id)=>{
      const metafield = metafields.find(obj => {return obj.id == el.productId} )
      if(el.hasBogo && metafield.bogo == false){
        toDelete[el.variantId] = 0;
        totalQuantityToDelete += el.currentQty;
        toAdd.push({
          id: el.variantId,
          quantity: el.newQty
        });
      }
      if(el.hasRates && el.ratesValue != metafield.rates) {
        toDelete[el.variantId] = 0;
        totalQuantityToDelete += el.currentQty;
      }
    });

    const totalToDelete = Object.keys(toDelete).length;
    if(Object.keys(toDelete).length > 0 ){
      updateProductCartLineItems(toDelete,-totalQuantityToDelete,function() {
        if(toAdd.length > 0){
          let totalToAdd = 0;
          toAdd.forEach((el,id) => {
            totalToAdd += el.quantity
          })
          addProductCartLineItems(toAdd,totalToAdd, function(){
          })
        }
      })
    }
  })
}

function myFunction() {
  document.getElementById("mobile-menu__help-wrapper").removeAttribute("aria-describedby");
  document.getElementById("mobile-menu__help-wrapper").removeAttribute("rel");
}

function alertModal(content) {
  const modal = document.getElementById('alert-modal');

  if (content !== undefined) {
    modal.querySelector('.content').innerHTML = content;
  }

  document.getElementsByTagName('body')[0].classList.add('overlay');
  modal.classList.remove('hidden');
}

function closeAlertModal() {
  document.getElementById('alert-modal').classList.add('hidden');
  document.getElementsByTagName('body')[0].classList.remove('overlay');
}

(function($){

  $('.search-bar__input-clear').on('click', function() {
    $('.search-bar__input').val('');
  });

  // Search page (Fast simon) logic
  if(window.location.href.includes('search-results')) {
    $('.search-bar__input').on('keyup', function(e) {
      if (e.keyCode == 13) {
        $('.search-bar__close-button').click();
        $(this).val('');
        $(this).blur();
      }
    });

    $('.search-bar__submit').on('click', function() {
      $('.search-bar__close-button').click();
    });
  }

  $(document).on('click', 'button[name="checkout"]', async() => {
    await handleCheckoutClick();
  });

  $(document).on('click', '#alert-modal .close-icon', closeAlertModal);
}(jQuery));

async function handleCheckoutClick() {
  const addContainers = document.querySelectorAll('[data-action="cart-recap__checkout"] .add-button-container');
  const containerSpinners = document.querySelectorAll('[data-action="cart-recap__checkout"] .container-spinner');
  addContainers.forEach(addContainer => {addContainer.style.display = 'none';});
  containerSpinners.forEach(containerSpinner=> {containerSpinner.style.display = 'inline-flex';});

  let updates = {};
  let alerts = [];
  let cartItems = Shopify.cart?.items;
  const alertTemplate = document.getElementById('max-qty-alert').innerHTML;

  if (!cartItems) {
    const cartResponse = await fetch(`${window.routes.cartUrl}.js`, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    });
    const cartData = await cartResponse.json();
    cartItems = cartData?.items;
  }

  for (const cartItem of cartItems) {
    const response = await fetch(`${window.routes.rootUrlWithoutSlash}/products/${cartItem.handle}?view=metafields`, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    const maxQty = parseInt(data.restrictions?.max_quantity);

    if (maxQty && cartItem.quantity > maxQty) {
      updates[`${cartItem.variant_id}`] = maxQty;
      alerts.push('<li>' + alertTemplate.replace('{{max}}', maxQty).replace('{{product}}', cartItem.title) + '</li>');
    }
  }

  if (Object.keys(updates).length) {
    alertModal(`<ul>${alerts.join('\n')}</ul>`);
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST',
      body: JSON.stringify({updates: updates})
    });
  }

  window.location.replace('/checkout');
}

/* VIDEO GALLERY CAROUSEL SECTION JS START */
$('.video_gallery_carousel_slider_main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.video_gallery_carousel_slider_nav'
});
$('.video_gallery_carousel_slider_nav').slick({
  slidesToShow: 4,
  slidesToScroll: 3,
  asNavFor: '.video_gallery_carousel_slider_main',
  arrows: true,
  prevArrow: $('.video_prev'),
  nextArrow: $('.video_next'),
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});
$('.video_gallery_carousel_slider_main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  $('.video_gallery_carousel_slider_main .slick-current iframe').attr('src', $('.video_gallery_carousel_slider_main .slick-current iframe').attr('src'));
  $(".video_gallery_carousel_slider_main video").each(function(){
    $(this).get(0).pause();
  });
});
/* VIDEO GALLERY CAROUSEL SECTION JS END */
function handlePDPSelectedSize(element) {
  const containerSelected = document.querySelector('.block-swatch-list .block-swatch.selected');
  containerSelected.querySelectorAll('input[type=radio]').forEach((e,i)=>{e.checked = false;});
  containerSelected.classList.remove('selected');
  element.parentNode.classList.add('selected')
  element.querySelectorAll('input[type=radio]').forEach((e,i)=>{e.checked = true;});
  document.querySelector('.product-form__variants .product-form__selected-value').innerHTML = element.dataset.size
}
$(window).load(function() {
  resetNavBarSize();
  hideNavbarElements();
});
function resetNavBarSize(){
  $("ul.nav-bar__linklist > li").each(function() {
    $(this).css( 'display', 'inline-block');
  });
}

function hideNavbarElements(){
  var arrayLenTotal = $("ul.nav-bar__linklist > li").length;
  var total=0;
  var baseWidth = $(window).width();
  for (var i = 0; i < arrayLenTotal; i+=1) {
    total+=$($("ul.nav-bar__linklist > li")[i]).outerWidth();
  }
  arrayLenTotal-=3;
  while(baseWidth - 10 < total)
  {
    total-=$($("ul.nav-bar__linklist > li")[arrayLenTotal]).outerWidth();
    if($("ul.nav-bar__linklist > li")[arrayLenTotal]){
      $("ul.nav-bar__linklist > li")[arrayLenTotal].style.display = 'none';
    }
    arrayLenTotal--;
  }
}
function isElementOnView(element,offsetTop = 0, offsetBottom = 0) {
    let elementTop = $(element).offset().top;
    let elementBottom = elementTop + $(element).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + window.innerHeight;

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

const pprPDP = {
  printSecondHalf: async () => {
    console.log('executing second half pdp');
    const response = await fetch(window.location.pathname+'?view=bottom');
    const main = document.querySelector('#main');
    const wrapper= document.createElement('div');
    wrapper.innerHTML = await response.text();
    main.insertBefore(wrapper,main.querySelector('section[data-section-type="product-reviews"]').parentNode)
    var x = new window.ProductRecommendationsSection(document.querySelector('section[data-section-type="product-recommendations"]'))
  }
}

function run(container){
  setInterval(function() {
      var current = container.getElementsByClassName('active')[0];
      current?.classList.remove('active');
      var next = current?.nextElementSibling || container.firstElementChild;
      next?.classList.add('active');
  }, 10000);
}
var wordSwap = document.getElementById('wordSwap');

if(wordSwap) {
  run(wordSwap);
}

// Country selector
(function($) {
  const toggleCountrySelector = function() {
    const isHidden = $('#country-selector-popover').attr('aria-hidden') == 'true' ? true : false;
    $('#country-selector-popover').attr('aria-hidden', !isHidden);
    $('button[aria-controls="country-selector-popover"]').attr('aria-expanded', isHidden);

    document.body.classList.remove('no-mobile-scroll');
    document.getElementById('country-selector-popover')?.closest('.header__action-item--country-selector')?.classList.remove('expanded');

    if (isHidden) {
      if ($(this).hasClass('country-selector-footer-button')) {
        document.body.classList.add('no-mobile-scroll');
        document.getElementById('country-selector-popover')?.closest('.header__action-item--country-selector')?.classList.add('expanded');
      }

      $('#country-selector-popover form').html('<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/></path></svg>');

      fetch(window.Shopify.routes.root + '?sections=country-selector')
      .then(res => res.json())
      .then(content => {
        $('#country-selector-popover form').html(content['country-selector'] + `<input type="hidden" name="return_to" value="${window.location.pathname}">`);
      });
    }
  };

  const changeSelectedValue = function(element, selector) {
    const form = element.closest('form');
    const isoCode = element.val();
    const codeField = selector == 'country-selector' ? 'country_code' : 'language_code';
    form.find(`input[name="${codeField}"]`).val(isoCode);

    $(`.${selector}-list li button`).each(function() {
      if ($(this).val() == isoCode) {
        $(this).attr('aria-current', true);

        const name = $(this).find('.name').text();
        $(`.${selector}`).find('.name').text(name)

        if (selector == 'country-selector') {
          const flag = $(this).find('.flag img').clone();
          $(`.${selector}`).find('.flag').html(flag);
        }
      } else {
        $(this).removeAttr('aria-current', false);
      }
    });
  }

  const toggleSelectorList = function(selector) {
    const other = selector == 'country-selector' ? 'language-selector' : 'country-selector';
    $(`.${other}-list`).attr('aria-hidden', true);
    $(`.${other}`).attr('aria-expanded', false);

    const isHidden = $(`.${selector}-list`).attr('aria-hidden') === 'true';
    $(`.${selector}-list`).attr('aria-hidden', !isHidden);
    $(`.${selector}`).attr('aria-expanded', isHidden);

    if (isHidden) {
      $(`.${selector}-list`).find('.find-item input').focus();
    }
  };

  $('.country-selector-button').on('click', toggleCountrySelector);
  $('#country-selector-popover').on('click', '.close-btn, .cancel-btn', toggleCountrySelector);
  $(document).on('click', function(event) {
    if (!event.target.closest('#country-selector-popover')
        && !event.target?.classList.contains('country-selector-button')
        && !event.target.closest('.country-selector-button')
        && $('#country-selector-popover').attr('aria-hidden') != 'true') {

      $('#country-selector-popover').attr('aria-hidden', true);
      $('button[aria-controls="country-selector-popover"]').attr('aria-expanded', false);
      document.body.classList.remove('no-mobile-scroll');
      document.getElementById('country-selector-popover')?.closest('.header__action-item--country-selector')?.classList.remove('expanded');
    }
  });

  $('#country-selector-popover').on('click', '.country-selector, .language-selector', function() {
    const selector = $(this).hasClass('country-selector') ? 'country-selector' : 'language-selector';
    toggleSelectorList(selector);
  });

  $('#country-selector-popover').on('click', '.country-selector-list button, .language-selector-list button', function(event) {
    const selector = $(this).closest('ul').hasClass('country-selector-list') ? 'country-selector' : 'language-selector';
    changeSelectedValue($(this), selector);
    toggleSelectorList(selector);
  });

  $('#country-selector-popover').on('keyup', '.country-selector-list .find-item input, .language-selector-list .find-item input', function() {
    const value = $(this).val().toLowerCase();
    const selector = $(this).closest('ul').hasClass('country-selector-list') ? 'country-selector' : 'language-selector';
    $(`.${selector}-list li:not(.find-item)`).filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
  });
})(jQuery);

/* Product Recipe Anchor Scroll to Section Offset */
(function($) {
  $('#productRecipe[href^="#"]').on('click',function (e) {
    e.preventDefault();
    var target = this.hash;
    var $trget = $(target);
    var newTop = $trget.offset().top - 140;
    $('html, body').animate ({
        scrollTop: newTop
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
  });
})(jQuery);

/* Video Widget */
function once(fn, context) {
  var result;
  return function() {
      if (fn) {
          result = fn.apply(context || this, arguments);
          fn = null;
      }
      return result;
  };
}

function moveAfter(move, to) {
  move.after(to);
}

function prVideoWidget(id, url, placeholder) {
  const videoWidget = document.querySelector('#videoWidget');
  const closeBtn = document.querySelector('#close');
  const prVideoContainer = document.querySelector('#video-widget-container');
  const footer = document.querySelector('footer');
  const move_once = once(moveAfter(footer, videoWidget));
  const videoElement = document.createElement('video');
        videoElement.src = url;
        videoElement.alt = "Lazy loaded video";
        videoElement.poster = placeholder;
        videoElement.controls = true;
        videoElement.preload = 'none';
        videoElement.id = 'prVideoWidget-'+id;
  const prVideoObserver = new IntersectionObserver(function (entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting) {

        prVideoContainer.appendChild(videoElement);

        videoElement.load();

        prVideoObserver.unobserve(prVideoContainer);
      }
    });
  }, {threshold: 1});

  move_once();
  document.body.classList.add('hide-chat');
  videoWidget.classList.toggle('hide');

  closeBtn.addEventListener('click', function(){
    videoWidget.classList.add('hide');
    prVideoContainer.innerHTML = '';
    document.body.classList.remove('hide-chat');
  });
  if (document.querySelector('#video-widget__btn')) {
    document.querySelector('#video-widget__btn').addEventListener('click', function() {
      document.querySelector('form.product-form-pdp').submit();
    }, false);
  }

  prVideoObserver.observe(prVideoContainer);
}
const videoWidgetLaunchBtns = document.querySelectorAll('.video-widget-launch-btn');
for (var i = 0; i < videoWidgetLaunchBtns.length; i++) {
  videoWidgetLaunchBtns[i].addEventListener('click', function(event) {
    event.preventDefault();
    var videoID = event.target.closest('button').dataset.video;
      var videoUrl = event.target.closest('button').dataset.videourl;
      var videoPlaceholder = event.target.closest('button').dataset.videoplaceholder;
      prVideoWidget(videoID, videoUrl, videoPlaceholder);
  }, false);
}